import { render, staticRenderFns } from "./ChangeDatatypeTab.vue?vue&type=template&id=007d86b0"
import script from "./ChangeDatatypeTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeDatatypeTab.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports